































import {
  CompanyCommerceParams
} from '@/store/interfaces/company_commerce';
import company_commerce from '@/store/types/company_commerce';
import { http } from '@/util/HTTP';
import { NemiPayNotifications } from '@/util/nemiPayNotifications';
import { AxiosResponse } from 'axios';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'Currencies',
  data() {
    return {
      http,
      currency: '',
      updating: false,
    };
  },
  computed: {
    ...mapGetters({
      singleCompanyCommerce: `companyCommerceModule/${company_commerce.getters.GET_SINGLE_COMPANY_COMMERCE}`,
    }),
  },
  watch: {
    singleCompanyCommerce: {
      handler(companyCommerce: CompanyCommerceParams) {
        this.currency = companyCommerce.currency ? companyCommerce.currency : '';
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      updateCompanyCommerce: `companyCommerceModule/${company_commerce.actions.UPDATE_COMPANY_COMMERCE}`,
    }),
    async updateCodeAndStatus(): Promise<void> {
      const notification = new NemiPayNotifications();

      const data = {
        company_commerce_id: this.singleCompanyCommerce.id,
        data: {
          currency: this.$data.currency,
        },
      };

      this.updateCompanyCommerce(data)
        .then((res: AxiosResponse<{ data: CompanyCommerceParams }>) => {
          notification.success('¡Éxito!', 'Monedas actualizadas correctamente');
          this.$store.commit(
            `companyCommerceModule/${company_commerce.mutations.SET_SINGLE_COMPANY_COMMERCE}`,
            res.data.data,
            { root: true, }
          );
          this.$emit('success');
        })
        .catch(() => {
          notification.warning('¡Error!', 'Algo ha salido mal :(');
        });
    },
  },
});
